<template>
  <div class="signContainer">
    <div class="signoHeader">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/personal/sign/home' }">签约管理</el-breadcrumb-item>
          <el-breadcrumb-item>发起签约</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <!-- <div class="authentication normalColor ft12">
        您还未进行实名认证！
        <span class="authBtn cursorPointer" @click="goAuth">去认证</span>
      </div>-->
      <div class="contract">
        <div class="title">合同文件</div>
        <span class="OperationGuide" @click="startGuideFn">操作引导</span>
        <slide
          class="slideCustomer"
          @deleteContract="deleteContract"
          @reNameContract="reNameContract"
          ref="slide"
        >
          <!-- <div class="swiperSlidecustomerAdd" slot="other" @click="toModelContract">
            <div>
              <div class="content slectHeight">
                <img src="@image/personalSign/contract_template_icon.png">
                <p class="selectDscp">选择合同模版</p>
              </div>
            </div>
          </div> -->
        </slide>
        <!-- <div class="signAnnex">
          <div class="annexTitle">
            <div style="margin-top:-17px;">添加附件</div>
          </div>
          <annex ref="annex" style="flex=1" :fileList="annexFileList" :showType="'upload'"></annex>
        </div> -->

        <el-form
          v-show="signPersonList.length"
          ref="contarctOwner"
          :model="contarctOwner"
          :rules="contarctOwnerRule"
          label-width="120px"
          class="contarctOwner"
          size="mini"
        >
          <!-- <el-form-item label="合同类型：" class="nameContract" prop="name">
            <el-radio-group v-model="contarctOwner.isOwner" fill="E88078" @change="isOwnerChange">
              <el-radio label="1">本人合同</el-radio>
              <el-radio label="2">授权合同</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <!-- <el-form-item label="授权人：" prop="powerId" v-if="contarctOwner.isOwner == 2">
            <el-select v-model="contarctOwner.powerId" @change="powerIdChange" placeholder="请选择">
              <el-option
                v-for="item in signPersonList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="paddingBox"></div>
    <div class="signContent">
      <div class="stepDscp sign_form">添加合同信息</div>
      <sign-form ref="form" @paymentType="paymentType" :data="detail.info"></sign-form>
    </div> 
    <div class="paddingBox"></div>
    <div class="signContent">
      <div class="stepDscp sort_table">添加合同签署方</div>
      <sort-table
        ref="table"
        :powerId="contarctOwner.powerId"
        @delete="deleteTableItem"
        @addOtherSignPerson="addOtherSignPerson"
        :data="detail.signatoryList"
      ></sort-table>
      <div class="routeChangeBox">
        <div class="routeChangeButton cursorPointer" @click="toIndex">放弃</div>
        <div class="routeChangeButton cursorPointer" :disabled="isSubmiting" @click="handlerNext">提交</div>
      </div>
    </div>
    <Dialog
      :visible="authDialogShow"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      :showClose="false"
      @closeDialog="closeDialog('authDialogShow')"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>您还没有通过实名认证，</p>
          <p>无法发起签约，请去实名认证！</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center;">
          <!-- <div class="button cursorPointer" @click="closeDialog('authDialogShow')">取消</div> -->
          <div class="button buttonActive cursorPointer" @click="goAuth">去认证</div>
        </div>
      </div>
    </Dialog>
    <Dialog
        :visible="emailDialogShow"
        :dialogTitle="'消息提示'"
        :width="'400px'"
        :showClose="false"
        @closeDialog="closeDialog('emailDialogShow')"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>请绑定邮箱，该邮箱今后会用来接收公证处的电子公证书</p>
<!--          <p>无法发起签约，请去实名认证！</p>-->
        </div>
        <div class="authHandlerBox" style="justify-content: center;">
          <!-- <div class="button cursorPointer" @click="closeDialog('authDialogShow')">取消</div> -->
          <div class="button buttonActive cursorPointer" @click="goEmail">立即绑定</div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="noPowerDialogShow"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      :showClose="false"
      @closeDialog="closeDialog('noPowerDialogShow')"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>你的授权已经被取消，如果想继续发起此授权合同，请联系授权人</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center;">
          <div class="button buttonActive cursorPointer" @click="goList">确定</div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="isOverFreeContract"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      :showClose="false"
      class="mealBox"
    >
      <div class="signDialog" slot="dialog">
        <div class="mealTop">
          <p>您尚有{{noPayContractConout}}个未支付的合同，不能再新建合同。</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center;">
          <div class="button buttonActive cursorPointer" @click="goList">确定</div>
        </div>
      </div>
    </Dialog>
     <ContractTypeDialog :visible="ShowContract.isShow"
      :appendToBody="true"
      :dialogTitle="ShowContract.title"
      :showClose="false"
      :showSlotClose="true"
      width="538px"
      @closeDialogSlotfq="closeDialogSlotfq"
      >
      <div slot="dialog-con" class="ContractType-con">
                <div class="item" @click="contractType_click('1')" :class="ContractType==1?'item_click':''">
                  <img src="../../../assets/images/personalSign/contract_fq.png" alt="" v-if="ContractType!=1">
                  <img src="../../../assets/images/personalSign/contract_fq_click.png" alt="" v-if="ContractType==1">
                  <div class="title" >赋强合同</div>
                  <div class="text" style="padding:0 20px">签署完成后，不仅可以发起合同公证还可以发起赋强公证</div>
                </div>
                <!-- ContractType -->
              <div class="item" @click="contractType_click('2')" :class="ContractType=='2'?'item_click':''">
                  <img src="../../../assets/images/personalSign/contract_pt.png" alt="" v-if="ContractType!=2">
                  <img src="../../../assets/images/personalSign/contract_pt_click.png" alt="" v-if="ContractType==2">
                  <div class="title" >普通合同</div>
                  <div class="text" style="padding:0 16px">签署完成后，可以发起合同公证</div>
              </div>
      </div>
      <div slot="dialog-btn" >
        <div class="flex">
          <el-button type="primary" class="subContract" :disabled="!ContractType" :style="{backgroundColor:ContractType?'':'#EAEAEA',border:ContractType?'':'0px solid'}"  @click="goContract">下一步</el-button>
        </div>
      </div>
    </ContractTypeDialog>
    <div class="returnPay" v-html="returnPay"></div>

    <div class="guideBoxo" v-if="startGuide">
      <div class="fristSetp" v-show="stepSQ==1">
        <div class="fristSetpCon">
          <img class="fristSetpImg" src="../../../assets/images/personalSign/scbdwj_img.png">
          <div class="fristSetpBox">
            <div>
              <img class="signHome_j" src="../../../assets/images/personalSign/connecting_line.png" />

              <div class="guodance_sign_bg">
                <div class="title">
                  <h3 >上传待签署文件</h3>
                  <div class="jumpOutFn" @click="jumpOutFn">我已了解 <i class="el-icon-close"></i></div>
                </div>
                <div class="text_list">
                  <b></b><p style="padding-left:12px;">上传待签署的合同草稿。仅支持PDF格式</p>
                </div>
                <div class="guodance_sign_bottom">
                  <p >（1 / 3）</p>
                  <button type="button" @click="secondStepSQFn">下一步</button>
                </div>
              </div>
              <!-- <img
                src="../../../assets/images/personalSign/next_nor_btn.png"
                @click="secondStepSQFn"
              >
              <img src="../../../assets/images/personalSign/tg_nor_btn.png" @click="jumpOutFn"> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="secondSetp" v-show="stepSQ==2">
        <div class="thirdStepBoxCon">
          <div class="thirdStepBox">
            <img src="../../../assets/images/personalSign/htlx_img.png">
          </div>
          <div class="fristSetpBox">
            <div>
              <img
                src="../../../assets/images/personalSign/next_nor_btn.png"
                @click="secondStepSQFn"
              >
              <img src="../../../assets/images/personalSign/tg_nor_btn.png" @click="jumpOutFn">
            </div>
          </div>
        </div>
      </div> -->
      <div class="thirdStep" v-show="stepSQ==2">
        <div class="thirdStepBoxCon">
          <div class="thirdStepBox">
            <img src="../../../assets/images/personalSign/newStep2.png" style="width:550px;margin-left:13px">
          </div>
          <div class="fristSetpBox">
            <div>
              <img class="signHome_j" src="../../../assets/images/personalSign/connecting_line.png" />
              <div class="guodance_sign_bg">
                <div class="title">
                  <h3 >为合同签署设置参数</h3>
                  <div class="jumpOutFn" @click="jumpOutFn">我已了解 <i class="el-icon-close"></i></div>
                </div>
                <div class="text_list">
                  <b></b><p style="padding-left:12px;">在 “合同有效期” ，录入约定的有效期</p>
                </div>
                <div class="text_list">
                  <b></b><p style="padding-left:12px;">在 “签约截至日期” 设置最晚签署期限，超过此期限则本合同作废</p>
                </div>
                <div class="guodance_sign_bottom">
                  <p >（2 / 3）</p>
                  <button type="button" @click="thirdStepSQFn">下一步</button>
                </div>
              </div>
              <!-- <img
                src="../../../assets/images/personalSign/next_nor_btn.png"
                @click="thirdStepSQFn"
              >
              <img src="../../../assets/images/personalSign/tg_nor_btn.png" @click="jumpOutFn"> -->
            </div>
          </div>
        </div>
      </div>
      <div class="fourStep" v-show="stepSQ==3">
        <div class=" thirdStepBoxCon1">
          <div class="thirdStepBox">
            <img class="fourStepImg" src="../../../assets/images/personalSign/sxqs_img.png">
          </div>
          <div class="fristSetpBox">
            <div>
                <img class="signHome_j" src="../../../assets/images/personalSign/connecting_line.png" />
                <div class="guodance_sign_bg">
                  <div class="title">
                    <h3 >选择签署顺序</h3>
                    <div class="jumpOutFn" @click="jumpOutFn">我已了解 <i class="el-icon-close"></i></div>
                  </div>
                  <div class="text_list">
                    <b></b><p style="padding-left:12px;">当确定 “顺序签署” 时，必须按照下表的顺序，从上到下进行签署。不能插队！</p>
                  </div>
                  <div class="text_list">
                    <b></b><p style="padding-left:12px;">当关闭 “顺序签署” 时，可以不受顺序约束，自由签署</p>
                  </div>
                  <div class="guodance_sign_bottom">
                    <p >（3 / 3）</p>
                    <button type="button" @click="jumpOutFn">我知道了</button>
                  </div>
                </div>
              <!-- <img src="../../../assets/images/personalSign/next_nor_btn.png" @click="fourStepSQFn">
              <img src="../../../assets/images/personalSign/tg_nor_btn.png" @click="jumpOutFn"> -->
            </div>
          </div>
         
        </div>
      </div>
      <div class="fiveStep" v-show="stepSQ==5">
        <div class="thirdStepBoxCon">
          <div class="fristSetpBox">
            <div>
              <img src="../../../assets/images/personalSign/kown_nor_btn.png" @click="jumpOutFn">
            </div>
          </div>
          <div class="thirdStepBox">
            <div class="fiveTableBob">
              <sort-table
                :powerId="contarctOwner.powerId"
                @delete="deleteTableItem"
                @addOtherSignPerson="addOtherSignPerson"
                :data="detail.signatoryList"
                :paymentTypeVlaue="paymentTypeVlaue"
                class="tableSign"
              ></sort-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="guideBoxn" v-if="startGuiden">
      <div class="fristSetp" v-show="step==1">
        <div class="fristSetpCon">
          <img class="fristSetpImg" src="../../../assets/images/personalSign/scbdwj_img.png">
          <div class="fristSetpBox">
            <div>
              <img src="../../../assets/images/personalSign/next_nor_btn.png" @click="firstStepFn">
              <img src="../../../assets/images/personalSign/tg_nor_btn.png" @click="jumpOutFn">
            </div>
          </div>
        </div>
      </div>
      <div class="thirdStep" v-show="step==2">
        <div class="thirdStepBoxCon">
          <div class="thirdStepBox">
            <img src="../../../assets/images/personalSign/htx_img.png">
          </div>
          <div class="fristSetpBox">
            <div>
              <img src="../../../assets/images/personalSign/next_nor_btn.png" @click="secondStepFn">
              <img src="../../../assets/images/personalSign/tg_nor_btn.png" @click="jumpOutFn">
            </div>
          </div>
        </div>
      </div>
      <div class="fourStep" v-show="step==3">
        <div class="thirdStepBoxCon">
          <div class="fristSetpBox">
            <div>
              <img src="../../../assets/images/personalSign/next_nor_btn.png" @click="thirdStepFn">
              <img src="../../../assets/images/personalSign/tg_nor_btn.png" @click="jumpOutFn">
            </div>
          </div>
          <img class="fourStepImg" src="../../../assets/images/personalSign/sxqs_img.png">
        </div>
      </div>
      <div class="fiveStep" v-show="step==4">
        <div class="thirdStepBoxCon">
          <div class="fristSetpBox">
            <div>
              <img src="../../../assets/images/personalSign/kown_nor_btn.png" @click="jumpOutFn">
            </div>
          </div>
          <div class="thirdStepBox">
            <div class="fiveTableBob">
              <sort-table
                :powerId="contarctOwner.powerId"
                @delete="deleteTableItem"
                @addOtherSignPerson="addOtherSignPerson"
                :data="detail.signatoryList"
                 :paymentTypeVlaue="paymentTypeVlaue"
                class="tableSign"
              ></sort-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog :visible="supplementFlag" :showClose="false" :dialogTitle="'消息提示'" @closeDialog="closeDialog('supplementFlag')" :width="'450px'">
        <div slot="dialog" class="supplement-con">        
           <p>{{supplementMsg}}</p>
           <button @click="nextTosupplement">下一步</button>         
        </div>
    </Dialog>
     <Dialog :visible="supplementFlagType" :dialogTitle="'消息提示'" :showClose="false" @closeDialog="closeDialog('supplementFlagType')" :width="'450px'">
        <div slot="dialog" class="supplement-con">      
          <span>当前实名主体为：</span>  
           <el-radio-group v-model="supplementFlagValue">
              <el-radio-button label="1" class="ContractType-radio">法人代表人</el-radio-button>
              <el-radio-button label="2" class="ContractType-radio">受托人</el-radio-button>
            </el-radio-group>
           <button @click="nextTosupplementType">下一步</button>         
        </div>
    </Dialog>
      <Dialog
      :visible="isHaveCreate"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      :showClose="false"
      class="mealBox"
    >
      <div class="signDialog" slot="dialog">
        <div class="mealTop">
          <p>该账号无权限执行此操作，请联系管理员处理</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center;">
          <div class="button buttonActive cursorPointer" @click="closeCreate">确定</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Breadcrumb from "../../../components/common/Breadcrumb.vue";
import sortTable from "./components/sign/sortTable.vue";
import slide from "./components/sign/slide.vue";
import signForm from "./components/sign/signForm.vue";
import Dialog from "@common/Dialog.vue";
import ContractTypeDialog from "@common/contractTypeDialog.vue";
import BaseApi from "@lib/baseApi.js";
import { mapGetters, mapMutations ,mapState} from "vuex";
import annex from "./components/sign/annex.vue";
export default {
  data() {
    let validatePowerId = (rule, value, callback) => {
      if (this.contarctOwner.isOwner == "2" && !value) {
        callback(new Error("请选择代理人"));
      } else {
        callback();
      }
    };
    return {
      step: 1,
      stepSQ: 1,
      startGuide: false,
      startGuiden: false,
      Paybalance: false,
      returnList: [],
      authentication: false,
      authDialogShow: false,
      noPowerDialogShow: false,
      returnPay: "",
      scrollLong: 0,
      scrollTop: 0,
      money: "",
      balance: 0,
      num: 0, //上传文件个数
      totalValue: 0,
      remainValue: 0,
      searchContractName: "",
      //是否正在提交
      isSubmiting: false,
      radio: "1", //支付方式
      payNo: "", //订单号,
      wechatresultImg: "",
      detail: {},
      trueState: false,
      contarctOwner: {
        isOwner: "1",
        powerId: ""
      },
      signPersonList: [],
      contarctOwnerRule: {
        powerId: [{ validator: validatePowerId, trigger: "change" }]
      },
      // 是否超过5个未支付的合同
      isOverFreeContract: false,
      //未支付的合同数，
      noPayContractConout: 0,
      // 编辑时的附件列表
      annexFileList: [],
      userInfoResult:{},
      curId:"",
      paymentTypeVlaue:"1",
      ShowContract:{
        isShow:false,
        title:"选择合同类型",
        showClose:true
      },
      ContractType:'1', // 赋强 '1' or 普通 '0'
       supplementFlag:false,//补充弹框
      supplementMsg:"平台账户体系升级，部分功能使用受限，为保障使用体验，您需补充部分机构信息。",
      supplementFlagType:false,
      supplementFlagValue:"1",

      /* 认证邮箱 */
      emailDialogShow: false,
      //验证权限
      isHaveCreate:false
    };
  },
  components: {
    Breadcrumb,
    slide,
    sortTable,
    signForm,
    Dialog,
    annex,
    ContractTypeDialog
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
   ...mapState(['currentInfo']),
    userInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  mounted() {
    $(".signContainer")[0].addEventListener("scroll", this.handleScroll);
    this.judgePowerWithCreateCon().then(flag => {
      if (flag == "Y") {
         this.createSign();
        if (this.$route.query.id) {
          this.getEditInfo();
        } else {
          this.getAgentOtherList();
        }
      }
    });
  },
  created() {
    this.createSign();
    this.contaractNum();
    this.keyupSubmit();
    this.$router.replace("/personal/sign/signLoanContract")
  },
  methods: {
    //关闭提示弹框
    closeCreate(){
      this.isHaveCreate=false;
      this.$router.go(-1);
    },
    //验证权限
     createSign() {
      if(this.getUserInfo.person.userId != this.getUserInfo.currentUserId){
        BaseApi.createRpcToken("/user/v2/getUserPermission", {}, "post")
        .then(value => {
          if(value.code == 200){
            if(!value.datas.permissionList.filter(item=>item.code == 'SIGN_ADD').length){
              this.isHaveCreate = true;
            }else{
              this.isHaveCreate = false;
              if (!this.getUserInfo.person.mail) {
                this.emailDialogShow = true;
              } else{
                this.getFQFileList();
              }
            }
          }
        })
        .catch(function(e) {
          errorLog(e);
        });
        // this.isHaveCreate=true;
      }else{
        this.isHaveCreate = false;
        if (!this.getUserInfo.person.mail) {
          this.emailDialogShow = true;
        } else {
          this.getFQFileList();
        }
      }
    },
    closeContract(){
      this.ShowContract.isShow=false;
    },
    //选择合同类型
    goContract(){
      if(this.ContractType=='2'){
        // this.closeContract()
        const step = this.$store.getters.getUserInfo.pageGuideProcess&&this.$store.getters.getUserInfo.pageGuideProcess['发起签约_普通']||0
        if(step){
          if(step == 1) {this.secondStepSQFn()}
          if(step == 2) {this.thirdStepSQFn()}
        }else if(step == 0){
          this.startGuideFn();
        }
      }else{
        //贷款合同
        this.$router.replace("/personal/sign/signLoanContract")
      }  
    },
    handleScroll() {
      this.scrollTop = $(".signContainer")[0].scrollTop;
    },
     //补充信息下一步
    nextTosupplement(){
      this.supplementFlag=false;
      this.supplementFlagType=true;
    },
    nextTosupplementType(){
      this.$router.push({
          path:'/personal/users/enterpriseSupplement',
          query:{
            step:this.step,
            flag:2,
            exId:'',
            supplementFlagValue:this.supplementFlagValue
          },
        })
    },
    //非授权合同操作指引
    firstStepFn() {
      this.step = 2;
      $(".signContainer").scrollTop(this.scrollLong);
      $(".thirdStepBoxCon")
        .eq(0)
        .css(
          "top",
          Number(
            $(".thirdStepBoxCon")
              .eq(0)
              .css("top")
              .split("px")[0]
          ) - this.scrollLong
        );
    },
    secondStepFn() {
      this.step = 3;
      $(".thirdStepBoxCon")
        .eq(1)
        .css(
          "top",
          Number(
            $(".thirdStepBoxCon")
              .eq(1)
              .css("top")
              .split("px")[0]
          ) - this.scrollLong
        );
    },
    thirdStepFn() {
      this.step = 4;
      $(".thirdStepBoxCon")
        .eq(2)
        .css(
          "top",
          Number(
            $(".thirdStepBoxCon")
              .eq(2)
              .css("top")
              .split("px")[0]
          ) - this.scrollLong
        );
    },
    //授权合同操作指引
    firstStepSQFn() {
      this.stepSQ = 2;
      if (this.scrollLong < 200) {
        $(".signContainer").scrollTop(this.scrollLong);
        $(".thirdStepBoxCon")
          .eq(0)
          .css(
            "top",
            Number(
              $(".thirdStepBoxCon")
                .eq(0)
                .css("top")
                .split("px")[0]
            ) - this.scrollLong
          );
      } else {
        $(".signContainer").scrollTop(200);
        $(".thirdStepBoxCon")
          .eq(0)
          .css(
            "top",
            Number(
              $(".thirdStepBoxCon")
                .eq(0)
                .css("top")
                .split("px")[0]
            ) 
          );
      }
    },
    secondStepSQFn() {
      this.stepSQ = 2;
      $(".signContainer").scrollTop(200);
     console.log( document.querySelector('.sign_form').getBoundingClientRect().top)
     console.log( document.querySelector('.sign_form').getBoundingClientRect().top)
     document.querySelector('.thirdStepBoxCon').style.top=document.querySelector('.sign_form').getBoundingClientRect().top+'px'
      // $(".thirdStepBoxCon")
      //   .eq(1)
      //   .css(
      //     "top",
      //     Number(
      //       $(".thirdStepBoxCon")
      //         .eq(1)
      //         .css("top")
      //         .split("px")[0]
      //     ) - this.scrollLong
      //   );
      // if(this.scrollLong<200){
      // }else{
      //   $('.thirdStepBoxCon').eq(1).css('top',Number($('.thirdStepBoxCon').eq(1).css('top').split('px')[0])-200)
      // }
    },
    thirdStepSQFn() {
      this.stepSQ = 3;
      $(".signContainer").scrollTop(300);
      console.log(document.querySelector('.thirdStepBoxCon'));
      document.querySelector('.thirdStepBoxCon1').style.top=document.querySelector('.handlerSort').getBoundingClientRect().top+'px'
      // $(".thirdStepBoxCon")
      //   .eq(2)
      //   .css(
      //     "top",
      //     Number(
      //       $(".thirdStepBoxCon")
      //         .eq(2)
      //         .css("top")
      //         .split("px")[0]
      //     ) - this.scrollLong
      //   );
    },
    fourStepSQFn() {
      this.stepSQ = 5;
      $(".thirdStepBoxCon")
        .eq(3)
        .css(
          "top",
          Number(
            $(".thirdStepBoxCon")
              .eq(3)
              .css("top")
              .split("px")[0]
          ) - this.scrollLong
        );
    },
    jumpOutFn() {
      this.startGuide = false;
      this.startGuiden = false;
    },
    startGuideFn() {
      if (this.signPersonList.length > 0) {
        this.startGuide = true;
        this.stepSQ = 1;
      } else {
        this.startGuiden = true;
        this.step = 1;
      }
      this.scrollLong =
      $(".signContainer")[0].scrollHeight - $(".signContainer").outerHeight();
      setTimeout(() => {
        $(".fristSetpCon").css(
          "top",
          Number(
            $(".fristSetpCon")
              .css("top")
              .split("px")[0]
          ) - this.scrollTop
        );
      }, 1);
    },
    // 获取用户信息
    getUserInfos() {
      return BaseApi.createRpcToken("/user/v2/getUserInfo");
    },
    //获取未支付的合同数
    getNoPayContractConout() {
      return BaseApi.createRpcToken("/contract/countNotPaid");
    },
    // 判断用户是否有权限发起合同
    async judgePowerWithCreateCon() {
      try {
        if (!this.$route.query.id) {
          // console.log(this.getUserInfo)
          if(this.getUserInfo.hasOwnProperty('currentUserId')){
            let data =this.getUserInfo;
            sessionStorage.setItem("userInfo", JSON.stringify(data));
            this.setUserInfo(data);
            if(data.currentUserId==data.person.userId){
              this.userInfoResult=data.person;
            }else{
              this.userInfoResult=data.enterpriseList[0];
            }
            if (!data.person || data.person.authenticationStatus != 2) {
              // 未实名显示弹窗禁止操作
              this.authDialogShow = true;
              return Promise.resolve("N");
            }
            if(this.currentInfo.realNameType==2){
              if (!data.person || data.person.authenticationStatus != 2) {
                // 未实名显示弹窗禁止操作
                this.authDialogShow = true;
                return Promise.resolve("N");
              }else{
                if(this.currentInfo.authenticationStatus!=2){
                  this.authDialogShow = true;
                  return Promise.resolve("N");
                }
              }
              if(this.currentInfo.authenticationStatus == 2 && (this.currentInfo.legalPersonStatus == 0 || this.currentInfo.legalPersonStatus == 1 || this.currentInfo.legalPersonStatus == 3 || this.currentInfo.legalPersonStatus == 5) ){
                //补充实名信息
                this.supplementFlag=true;
                return Promise.resolve("N");
              } 
            }

            if (!data.person.mail) {
              this.emailDialogShow = true;
              return Promise.resolve("N");
            }
          }else{
            let data =await this.getUserInfos();
            sessionStorage.setItem("userInfo", JSON.stringify(data.datas));
            this.setUserInfo(data.datas);
            if(data.datas.currentUserId==data.datas.person.userId){
              this.userInfoResult=data.datas.person;
            }else{
              this.userInfoResult=data.datas.enterpriseList[0];
            }
            if (!data.datas.person || data.datas.person.authenticationStatus != 2) {
              // 未实名显示弹窗禁止操作
              this.authDialogShow = true;
              return Promise.resolve("N");
            }
            if(this.currentInfo.realNameType==2){
              if (!data.datas.person || data.datas.person.authenticationStatus != 2) {
                // 未实名显示弹窗禁止操作
                this.authDialogShow = true;
                return Promise.resolve("N");
              }else{
                if(this.currentInfo.authenticationStatus!=2){
                    this.authDialogShow = true;
                    return Promise.resolve("N");
                }
              }
               if(this.currentInfo.authenticationStatus == 2 && (this.currentInfo.legalPersonStatus == 0 || this.currentInfo.legalPersonStatus == 3 || this.currentInfo.legalPersonStatus == 5)){
                //补充实名信息
                this.supplementFlag=true;
                return Promise.resolve("N");
              } 
            }
          }
          
          //  判断未支付的合同个数 大于5禁止新建
          let noPayContractInfo = await this.getNoPayContractConout();
          this.noPayContractConout =
            (noPayContractInfo.datas &&
              noPayContractInfo.datas.count &&
              noPayContractInfo.datas.count - 0) ||
            0;
          if (this.noPayContractConout >= 5) {
            this.isOverFreeContract = true;
            return Promise.resolve("N");
          }
          return Promise.resolve("Y");
        } else {
          return Promise.resolve("Y");
        }
      } catch (e) {
      }
    },
    // 得到编辑信息
    async getEditInfo() {
      let signPersonInfo = await this.getAgentOtherList(true);
      let signPersonList = signPersonInfo.datas.list;
      this.signPersonList = signPersonList;
      BaseApi.createRpcToken("/contract/find", {
        id: this.$route.query.id
      }).then(
        data => {
          try {
            let detail = data.datas.contract;
            // console.log(this.getUserInfo)
            if (detail.info.userId !== this.currentInfo.userId || detail.info.createUserId!==this.getUserInfo.person.userId) {
              this.contarctOwner.isOwner = "2";
              let isHavePower = false;
              
              for (let i = 0; i < signPersonList.length; i++) {
                if (signPersonList[i].value == detail.info.userId) {
                  this.signPersonList = signPersonList;
                  isHavePower = true;
                  this.$nextTick(() => {
                    this.contarctOwner.powerId = detail.info.userId;
                  });
                  break;
                }
              }
              if (!isHavePower) {
                //需要显示发送
                this.noPowerDialogShow = true;
              }
            }
            // this.annexFileList = detail.attachmentList;
            this.contractId = this.$route.query.id;
            this.$refs.slide.setData(detail.fileList);
            this.$refs.form.setData(detail.info);
            detail.signatoryList.forEach(item=>{
              if(item.type==2){
                item.mail=""
              }
            })
            this.$refs.table.setData(detail.signatoryList);
          } catch (e) {}
        },
        err => {}
      );
    },
    keyupSubmit() {
      document.onkeydown = e => {
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.handlerNext();
        }
      };
    },
    contaractNum(data) {
      this.num = data;
    },
    goList() {
      this.$router.push("/personal/sign/home");
    },
    //获取赋强合同
    getFQFileList() {
        this.$store.commit('showLoading',true);
        BaseApi.createRpcToken("/fqContract/getEixtFqContractTemplate").then(
          data => {
            this.$store.commit('showLoading',false);
            if(this.$route.query.type==1 && this.$route.query.from=='draft'){
              this.ShowContract.isShow=true;
            }else{
              this.ShowContract.isShow=true;
            }
          },
          err => {}
        );
    },
    getAgentOtherList(isAsync) {
      if (!isAsync) {
        BaseApi.createRpcToken("/agent/getPrincipal").then(
          data => {
            this.signPersonList = data.datas.list;
          },
          err => {}
        );
      } else {
        return BaseApi.createRpcToken("/agent/getPrincipal");
      }
    },
    //选择支付方式
    paymentType(data){
      this.paymentTypeVlaue=data;
    },
    powerIdChange(value = localStorage.userId) {
      this.$refs.table.restList(value);
    },
    isOwnerChange() {
      if (this.contarctOwner.isOwner == 1) {
        this.contarctOwner.powerId = "";
        this.powerIdChange();
      }
    },
    ...mapMutations(["setUserInfo"]),
    goAuth() {
      //去认证页面
      let exuserid=sessionStorage.getItem("userInfo")?JSON.parse(sessionStorage.getItem("userInfo")):''
      if(exuserid.person.authenticationStatus!=2 ){
          this.$router.push({
            path:'/personal/users/home',
            query:{
              userId:exuserid.person.userId
            },
          })
      }else{
         this.$router.push({
            path:'/personal/users/enterprise',
            query:{
              step:this.step,
              exId:exuserid.enterpriseList.length?exuserid.enterpriseList[0].userId:''
            },
          })
      } 
      this.authDialogShow=false;
    },
    goEmail() {
      //去绑定邮箱
      this.$router.push({
        name:'userHome',
        params:{
          signPage: true
        },
      })
    },
    closeDialog(flag) {
      this[flag] = false;
      
    },
    toModelContract() {
      this.$router.push("/personal/sign/record");
    },
   async handlerNext() {
      let that = this;
      this.$refs.contarctOwner.validate();
       //付费方式
      let paymentType = this.$refs.form.paymentTypeChange();
      if (this.currentInfo.success) {
       let slideData = this.$refs.slide.save();
        let formData = await this.$refs.form.save();
        let tableData = this.$refs.table.save();
        if (!slideData.valid) {
          this.$message.error(slideData.validMessage);
          return;
        } else if (!tableData.valid) {
          this.$message.error(tableData.validMessage);
          return;
        } else if (!formData.valid) {
          return;
        } else if (
          this.contarctOwner.isOwner == 2 &&
          !this.contarctOwner.powerId
        ) {
          return;
        }else if(tableData.isSumC){
         this.$message.error("系统默认的签署方支付费用无法进行提交，请您修改金额后再提交");
          return;
        } else if(tableData.isValyes==0 && paymentType==2 && !tableData.isSumC){
         this.$message.error("您输入的签约费用小于应支付限额！");
          return;
        }else if(tableData.isValyes==1 && paymentType==2 && !tableData.isSumC){
          this.$message.error("您输入的签约费用超出应支付限额！");
          return;
        }else{
          let params = Object.assign({}, formData.data);
          params.signatoryIds = tableData.data.join(",");
          params.fileIds = slideData.data.join(",");
          params.orderType = tableData.orderType;
          params.type=1;
          params.signatoryAmount=JSON.stringify(tableData.signatoryAmount)
          params.payMode=paymentType;
          if (!this.isSubmiting) {
            this.isSubmiting = true;
            if (this.contractId) {
              params.id = this.contractId;
            }
            // 如果选择代理人就参数需要增加 userid
            if (this.contarctOwner.powerId) {
              params.contractUserId = this.contarctOwner.powerId;
            }
            BaseApi.createRpcToken("/contract/add", params, "post").then(
              data => {
                if(data.datas==null && paymentType=='2'){
                  this.$message.error("添加的签署方存在未注册用户，请添加已注册的签署方！");
                  this.isSubmiting = false;
                  return;
                }
                this.contractId = data.datas.id;
                //发起方付费
                if(paymentType == 1){
                  // 判断是否已经支付过
                  this.getContractInfo().then(
                    async function(data) {
                      if (data.datas.info.payStatus == 0) {
                        //去支付
                        that.$router.push({
                          path:"/personal/payment",
                          query:{ id: that.contractId,flag:'startSign',type:1}
                        })
                      } else {
                        that.$router.push({
                          path: `/personal/sign/complete?id=${
                            that.contractId
                          }&flag=startSign&type=1`
                        });
                      }
                      that.isSubmiting = false;
                    },
                    () => {
                      that.isSubmiting = false;
                    }
                  );
                }
                //各签署方付费
                else if(paymentType == 2){
                   that.$router.push({
                      path: `/personal/sign/complete?id=${
                        that.contractId
                      }&flag=startSign&type=1`
                    });
                }
              },
              () => {
                this.isSubmiting = false;
              }
            );
          }
        }
      } else {
        this.authDialogShow = true;
      }
    },
    deleteTableItem(row) {},
    deleteContract(data) {
      this.deleteDialogShow = true;
    },
    reNameContract(data) {
      this.renameDialogShow = true;
    },
    addOtherSignPerson() {
      this.signListShow = true;
    },
    toIndex() {
      this.$router.push("/personal/sign/home");
    },
    getContractInfo() {
      return BaseApi.createRpcToken(
        "/contract/info",
        { id: this.contractId },
        "post"
      );
    },
    contractType_click(val){
      this.ContractType=val
    },

    closeDialogSlotfq() {
      this.$router.go(-1);
    }
  },
  watch:{
    "getUserInfo.currentUserId"(data){
      this.judgePowerWithCreateCon();
      console.log(this.currentInfo , "----------------------------")
      if(this.currentInfo.realNameType == '2'){
        if(this.currentInfo.authenticationStatus == 2 && (this.currentInfo.legalPersonStatus == 0 || this.currentInfo.legalPersonStatus == 3 || this.currentInfo.legalPersonStatus == 5)  ){
          
        }else{
          this.createSign();
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.signContainer {
  .el-radio__label,
  .el-radio__input.is-checked + .el-radio__label {
    font-size: 12px;
    color: #969696;
    padding-left: 10px;
  }
  .is-focus .el-radio__input .el-radio__inner {
    border: 1px solid #dcdfe6;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #e88078;
    background: #e88078;
  }
  .el-form-item__label {
    font-size: 12px;
    color: #969696;
  }
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  .signoHeader {
    padding: 20px 20px 0 20px;
    .authentication {
      height: 30px;
      line-height: 30px;
      background: #fbeceb;
      padding-left: 19px;
      .authBtn {
        border: 1px solid #e88078;
        border-radius: 3px;
        display: inline-block;
        padding: 3px 15px;
        line-height: 12px;
        margin-left: 20px;
      }
    }
    .contract {
      overflow: hidden;
      width: 100%;
      padding-top: 30px;
      position: relative;
      .OperationGuide {
        position: absolute;
        right: 0;
        font-size: 14px;
        color: #0082ff;
        cursor: pointer;
      }
      .contarctOwner {
        // border-top: 1px solid #dcdcdc;
        clear: both;
        padding: 20px 0 10px 0;
      }
      .title {
        float: left;
        height: 200px;
        width: 70px;
        line-height: 200px;
        font-size: 14px;
        color: #969696;
      }
      .signAnnex {
        display: flex;
        width: 100%;
        height: auto;
      }
      .annexTitle {
        width: 147px;
        font-size: 14px;
        color: #969696;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .slideCustomer {
        float: left;
        height: 200px;
        width: calc(100% - 70px);
        margin-bottom: 40px;
      }
      .swiperSlidecustomerAdd {
        float: left;
        margin:0PX 10px;
        width: 160px;
        height: 200px;
        position: relative;
        cursor: pointer;
        .content {
          &:hover {
            background-color: rgb(240, 240, 240);
          }
          width: 100%;
          height: 146px;
          box-sizing: border-box;
          padding: 10px;
          background-color: rgb(248, 248, 248);
          display: flex;
          justify-content: center;
          align-items: center;
          .selectDscp {
            font-size: 14px;
            color: #646464;
            margin-top: 14px;
          }
        }
        .slectHeight {
          height: 200px;
          flex-direction: column;
        }
        .cover {
          display: none;
        }
        &:hover {
          .cover {
            position: absolute;
            display: block;
            width: 100%;
            height: 146px;
            left: 0;
            top: 0;
            z-index: 1;
            img {
              height: 146px;
              width: 160px;
              display: block;
            }
          }
        }
        .coverDscp {
          position: absolute;
          z-index: 2;
          width: 160px;
          box-sizing: border-box;
          height: 55px;
          line-height: 55px;
          bottom: 0;
          border: 1px solid rgb(240, 240, 240);
          background-color: white;
          font-size: 14px;
          color: #646464;
          text-align: center;
        }
      }
    }
  }
  .paddingBox {
    width: 100%;
    height: 10px;
    background: #eaedf1;
  }
  .signContent {
    width: 100%;
    // height: calc(100% - 416px);
    box-sizing: border-box;
    padding: 30px 20px 49px 20px;
    .stepDscp {
      height: 22px;
      font-size: 14px;
      color: #505050;
      font-weight: 600;
      border-bottom: 1px solid #dcdcdc;
      margin-bottom: 20px;
    }
    .routeChangeBox {
      text-align: center;
      height: 34px;
      .routeChangeButton {
        display: inline-block;
        width: 160px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 12px;
        border-radius: 5px;
        color: #646464;
        border: 1px solid #c8c8c8;
        &:hover {
          background-color: #a5303d;
          border: 1px solid #a5303d;
          color: white;
        }
      }
      & > .routeChangeButton:first-child {
        margin-right: 20px;
      }
    }
  }
  .signDialog {
    height: 200px;
    width: 400px;
    box-sizing: border-box;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 0 20px;
    .authDscp {
      font-size: 14px;
      color: #646464;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      padding-top: 20px;
    }
    .withInput {
      width: 100%;
      text-align: left;
      .el-input__inner {
        width: 100%;
        height: 32px;
        line-height: 32px;
      }
    }
  }
  .signDialogs {
    height: 200px;
    width: 400px;
    box-sizing: border-box;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 0 20px;
    .withInput {
      width: 100%;
      text-align: left;
      p {
        margin-bottom: 10px;
      }
      .el-input__inner {
        width: 100%;
        height: 32px;
        line-height: 32px;
      }
    }
  }
  .mealBox {
    .mealCon {
      height: 200px;
      .mealTop {
        height: 138px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        p {
          font-size: 14px;
          color: #646464;
          letter-spacing: 0;
          text-align: center;
          line-height: 22px;
        }
      }
      .mealBottom {
        display: flex;
        justify-content: center;
        span {
          display: inline-block;
          width: 100px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #c8c8c8;
          font-size: 12px;
          color: #646464;
          cursor: pointer;
        }
        span:nth-child(2) {
          color: #fff;
          background: #D81212;
          border-color: #D81212;
          margin-left: 40px;
        }
      }
    }
    .balanceCon {
      height: 200px;
      .mealTop {
        height: 138px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        h1 {
          font-size: 36px;
          color: #e72525;
          line-height: 36px;
          font-weight: normal;
        }
        p:nth-child(2) {
          font-size: 14px;
          color: #919191;
          line-height: 14px;
          margin-top: 6px;
          margin-bottom: 10px;
        }
        p:nth-child(3) {
          font-size: 14px;
          color: #919191;
        }
      }
      .mealBottom {
        display: flex;
        justify-content: center;
        span {
          display: inline-block;
          width: 100px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #c8c8c8;
          font-size: 12px;
          color: #646464;
          cursor: pointer;
        }
        span:nth-child(2) {
          color: #fff;
          background: #D81212;
          border-color: #D81212;
          margin-left: 40px;
        }
      }
    }
  }
  .ContractBox{
    width: 520px;
    height: 400px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    box-sizing: border-box;
    .el-dialog__header {
      display: block;
      padding: 0px;
      border-bottom: 1px solid #E9E9E9;
      padding: 20px;

    }
    .ContractType-con{
      // background-color: pink;
      margin-top: 0 !important;
      display:flex;
      padding:18px 32px 0 ;
      // justify-content: space-around;
      .el-radio{
        margin-right: 0;
      }
      .item{
        width: 228px;
        height: 233px;
        background-color: #F7F8FA;
        display:flex;
        align-items: center;
        flex-direction: column;
        border-radius: 4px 4px 4px 4px;
        box-sizing: border-box;
        &:hover {
          box-shadow: 0 0 5px #D81212;
        }
        cursor: pointer;
          .title{
            color: #555555;
            font-size:16px;
            line-height: 23px;
            margin:16px 0;
          }
          img{
            margin: 0 auto ;
            width: 80px;
            height: 80px;
            margin-top:24px;
          }
          .text{
            line-height: 23px;
            color:#979797;
            margin-bottom:4px;
          }
      }
      .item_click{
        border: 1px solid #C62E3F;
        .title{
          color:#C62E3F;
        }
      }
      .item:nth-child(1){
        margin-right:18px;
      }
      
      .el-radio__input{
        display:none;
      }
      .el-radio-button__inner{
        margin-left: 14px;
        width: 100px;
        height: 36px;
        background: #FFFFFF;
        box-shadow: none;
        border-radius: 18px;
        border: 1px solid #D9D9D9;
        outline: none;
        padding: 11px 20px;
      }
      .el-radio-button__inner:hover{
         color: #5B5B5B;
      }
       .el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #FFF0F0;
              border: 1px solid #D81212;
              color: #D81212;
        }
    }
    .flex{
      display: flex;
      justify-content: center;
    }
  

  }
  .guideBoxo {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(100, 100, 100, 0.5);
    z-index: 999999999999;
    .fristSetp {
      width: 100%;
      height: 100%;
      position: relative;
      // display: none;
      .fristSetpCon {
        position: absolute;
        left: 351px;
        top: 145px;
        .fristSetpBox {
          width: 490px;
          height: 222px;
          // background: url("../../../assets/images/personalSign/word_1th_img.png") no-repeat;
          background-size: cover;
          margin-top: -208px;
          margin-left: 542px;
          .signHome_j {
            width: 340px;
            height: 11px;
            position: absolute;
            top: 100px;
            left: 183px;
          }
          .guodance_sign_bg {
            padding: 20px;
            width: 439px;
            min-height: 106px;
            // background: url("../../assets/images/guidance/signHome_mask.png");
            background-position: center center;
            background-size: 100% 100%;
          background-color: #ffffff;

            .title{
              display:flex;
              justify-content:space-between;
              .jumpOutFn{
                color:#979797;
                font-size: 13px;
                cursor: pointer;
              }
            }
            h3 {
              font-size: 20px;
              color: #000000;
              line-height: 26px;
              margin-bottom: 10px;
            }
            .text_list {
              font-size: 14px;
              color: #4f4f4f;
              line-height: 24px;
              height: 30px;
              b {
                width: 6px;
                height: 6px;
                background: #cc0404;
                border-radius: 50%;
                display: inline-block;
                float: left;
                margin-top: 8px;
                margin-right: 8px;
              }
            }
            .guodance_sign_bottom {
              width: 100%;
              margin-top: 30px;
              display: flex;
              height: 36px;
              justify-content: space-between;
              align-items: center;
              p {
                font-size: 14px;
                color: #b2afaf;
              }
              button {
                width: 96px;
                height: 36px;
                background: #d01f1f;
                border-color: #d01f1f;
                border-radius: 4px;
                color: #fff;
                font-size: 18px;
                cursor: pointer;
              }
            }
          }
          // div {
          //   position: relative;
          //   width: 100%;
          //   height: 100%;
          //   img:nth-child(1) {
          //     position: absolute;
          //     bottom: 20px;
          //     left: 80px;
          //   }
          //   img:nth-child(2) {
          //     position: absolute;
          //     bottom: 27px;
          //     left: 230px;
          //   }
          // }
        }
      }
    }
    .secondSetp {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        position: absolute;
        width: 100%;
        top: 375px;
        left: 10px;
        .thirdStepBox {
          background-color: #fff;
          width: calc(100% - 30px);
          padding: 20px 55px;
          box-sizing: border-box;
        }
        .fristSetpBox {
          margin-top: 20px;
          margin-left: 200px;
          width: 348px;
          height: 222px;
          background: url("../../../assets/images/personalSign/worf_sq_2th_img.png")
            no-repeat;
          background-size: 100% 100%;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img:nth-child(1) {
              position: absolute;
              bottom: 20px;
              left: 80px;
            }
            img:nth-child(2) {
              position: absolute;
              bottom: 27px;
              left: 230px;
            }
          }
        }
      }
    }
    .thirdStep {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        width: calc(100% - 40px);
        position: absolute;
        // top: 35vh;
        left: 2vh;
        .thirdStepBox {
          // background-color: #fff;
          // width: 100%;
          padding: 20px 30px 20px 0;
          box-sizing: border-box;
          img{
            transform: scale(0.9);
            position: relative;
            left: -43px;
          }
        }
        .fristSetpBox {
          width: 490px;
          height: 222px;
          margin-top: -262px;
          margin-left: 684px;
         /*  background: url("../../../assets/images/personalSign/word_sq_3th_img.png")
            no-repeat; */
          background-size: 100% 100%;
          .signHome_j {
            width: 228px;
            height: 11px;
            position: absolute;
            top: 134px;
            left: 501px;
            z-index: -1;
          }
          .guodance_sign_bg {
            background-color: #ffffff;
            padding: 20px;
            width: 439px;
            min-height: 106px;
            // background: url("../../assets/images/guidance/signHome_mask.png");
            background-position: center center;
            background-size: 100% 100%;
            .title{
              display:flex;
              justify-content:space-between;
              .jumpOutFn{
                color:#979797;
                font-size: 13px;
                cursor: pointer;
              }
            }
            h3 {
              font-size: 20px;
              color: #000000;
              line-height: 26px;
              margin-bottom: 10px;
            }
            .text_list {
              font-size: 14px;
              color: #4f4f4f;
              line-height: 24px;
              height: 30px;
              b {
                width: 6px;
                height: 6px;
                background: #cc0404;
                border-radius: 50%;
                display: inline-block;
                float: left;
                margin-top: 8px;
                margin-right: 8px;
              }
            }
            .guodance_sign_bottom {
              width: 100%;
              margin-top: 30px;
              display: flex;
              height: 36px;
              justify-content: space-between;
              align-items: center;
              p {
                font-size: 14px;
                color: #b2afaf;
              }
              button {
                width: 96px;
                height: 36px;
                background: #d01f1f;
                border-color: #d01f1f;
                border-radius: 4px;
                color: #fff;
                font-size: 18px;
                cursor: pointer;
              }
            }
          }
          // div {
          //   position: relative;
          //   width: 100%;
          //   height: 100%;
          //   img:nth-child(1) {
          //     position: absolute;
          //     bottom: 20px;
          //     left: 80px;
          //   }
          //   img:nth-child(2) {
          //     position: absolute;
          //     bottom: 27px;
          //     left: 230px;
          //   }
          // }
        }
      }
    }
    .fourStep {
      min-width: 1200px;
      // height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon1 {
        position: absolute;
        // top: 51vh !important;
        left: 2vh;
        .fourStepImg {
          margin-top:170px;
        }
        .fristSetpBox {
          // width: 476px;
          // height: 200px;
          margin-left: 684px;
          position:absolute;
          top: -65px;
          background-color: #fff;
          /* background: url("../../../assets/images/personalSign/word_sq_4th_img.png")
            no-repeat; */
          background-size: 100% 100%;
          .signHome_j {
            width: 423px;
            height: 11px;
            position: absolute;
            top: 80px;
            left: -452px;
          }
          .guodance_sign_bg {
            padding: 20px;
            width: 439px;
            min-height: 106px;
            // background: url("../../assets/images/guidance/signHome_mask.png");
            background-position: center center;
            background-size: 100% 100%;
            .title{
              display:flex;
              justify-content:space-between;
              .jumpOutFn{
                color:#979797;
                font-size: 13px;
                cursor: pointer;
              }
            }
            h3 {
              font-size: 20px;
              color: #000000;
              line-height: 26px;
              margin-bottom: 10px;
            }
            .text_list {
              font-size: 14px;
              color: #4f4f4f;
              line-height: 24px;
              height: 50px;
              b {
                width: 6px;
                height: 6px;
                background: #cc0404;
                border-radius: 50%;
                display: inline-block;
                float: left;
                margin-top: 8px;
                margin-right: 8px;
              }
            }
            .guodance_sign_bottom {
              width: 100%;
              // margin-top: 30px;
              display: flex;
              height: 36px;
              justify-content: space-between;
              align-items: center;
              p {
                font-size: 14px;
                color: #b2afaf;
              }
              button {
                width: 96px;
                height: 36px;
                background: #d01f1f;
                border-color: #d01f1f;
                border-radius: 4px;
                color: #fff;
                font-size: 18px;
                cursor: pointer;
              }
            }
          }
          // div {
          //   position: relative;
          //   width: 100%;
          //   height: 100%;
          //   img:nth-child(1) {
          //     position: absolute;
          //     bottom: 20px;
          //     left: 136px;
          //   }
          //   img:nth-child(2) {
          //     position: absolute;
          //     bottom: 27px;
          //     left: 275px;
          //   }
          // }
        }
        .thirdStepBox{
          position: absolute;
          top: -171px;
        }
      }
    }
    .fiveStep {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        width: calc(100% - 40px);
        position: absolute;
        top: 471px;
        left: 20px;
        .thirdStepBox {
          background-color: #fff;
          box-sizing: border-box;
          .fiveTableBob {
            width: 100%;
            height: 178px;
            padding-top: 20px;
            .tableSign {
              position: relative;
            }
            .tableSign:after {
              content: "";
              position: absolute;
              top: 10px;
              width: 200px;
              height: 30px;
              background-color: #fff;
            }
            .tableSign:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1111;
            }
          }
        }
        .fristSetpBox {
          width: 348px;
          height: 222px;
          margin-left: 300px;
          margin-bottom: 20px;
          background: url("../../../assets/images/personalSign/word_sq_5th_img.png")
            no-repeat;
          background-size: 100% 100%;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img {
              position: absolute;
              bottom: 76px;
              left: 115px;
            }
          }
        }
      }
    }
  }
  .guideBoxn {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(100, 100, 100, 0.5);
    z-index: 999999999999;
    .fristSetp {
      width: 100%;
      height: 100%;
      position: relative;
      // display: none;
      .fristSetpCon {
        position: absolute;
        left: 360px;
        top: 145px;
        .fristSetpBox {
          width: 348px;
          height: 222px;
          background: url("../../../assets/images/personalSign/word_1th_img.png")
            no-repeat;
          background-size: cover;
          margin-top: 20px;
          margin-left: 107px;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img:nth-child(1) {
              position: absolute;
              bottom: 20px;
              left: 80px;
            }
            img:nth-child(2) {
              position: absolute;
              bottom: 27px;
              left: 230px;
            }
          }
        }
      }
    }
    .thirdStep {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        width: calc(100% - 40px);
        position: absolute;
        top: 445px;
        left: 20px;
        .thirdStepBox {
          background-color: #fff;
          width: 100%;
          padding: 20px 30px;
          box-sizing: border-box;
        }
        .fristSetpBox {
          width: 348px;
          height: 222px;
          margin-top: 20px;
          margin-left: 300px;
          background: url("../../../assets/images/personalSign/worf_2th_img.png")
            no-repeat;
          background-size: 100% 100%;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img:nth-child(1) {
              position: absolute;
              bottom: 20px;
              left: 80px;
            }
            img:nth-child(2) {
              position: absolute;
              bottom: 27px;
              left: 230px;
            }
          }
        }
      }
    }
    .fourStep {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        position: absolute;
        top: 510px;
        left: 20px;
        .fourStepImg {
          background-color: #fff;
        }
        .fristSetpBox {
          width: 400px;
          height: 170px;
          margin-left: 200px;
          background: url("../../../assets/images/personalSign/word_3th_img.png")
            no-repeat;
          background-size: 100% 100%;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img:nth-child(1) {
              position: absolute;
              bottom: 20px;
              left: 136px;
            }
            img:nth-child(2) {
              position: absolute;
              bottom: 27px;
              left: 275px;
            }
          }
        }
      }
    }
    .fiveStep {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        width: calc(100% - 40px);
        position: absolute;
        top: 392px;
        left: 20px;
        .thirdStepBox {
          background-color: #fff;
          box-sizing: border-box;
          .fiveTableBob {
            width: 100%;
            height: 178px;
            padding-top: 20px;
            .tableSign {
              position: relative;
            }
            .tableSign:after {
              content: "";
              position: absolute;
              top: 10px;
              width: 200px;
              height: 30px;
              background-color: #fff;
            }
            .tableSign:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1111;
            }
          }
        }
        .fristSetpBox {
          width: 348px;
          height: 222px;
          margin-left: 300px;
          margin-bottom: 20px;
          background: url("../../../assets/images/personalSign/word_4th_img.png")
            no-repeat;
          background-size: 100% 100%;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img {
              position: absolute;
              bottom: 76px;
              left: 115px;
            }
          }
        }
      }
    }
  }
}
.supplement-con{
  width: 100%;
  text-align: left;
  padding: 30px 24px;
  box-sizing: border-box;
      .el-radio-button__inner{
        margin-left: 14px;
        width: 100px;
        height: 36px;
        background: #FFFFFF !important;
        box-shadow: none;
        border-radius: 18px !important;
        border: 1px solid #D9D9D9 !important;
        outline: none;
        text-align: center !important;
        padding: 11px 0px !important;
      }
      .el-radio-button__inner:hover{
         color: #5B5B5B ;
      }
       .el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #FFF0F0;
              border-color: #D81212 !important;
              color: #D81212 !important;
              box-shadow:-1px 0 0 0 #fff;
        }
  button{
    display: block;
    width: 100px;
height: 32px;
background: #FFFFFF;
border: 1px solid #D81212;
text-align: center;
color: #D81212;
cursor: pointer;
margin: 0 auto;
margin-top: 20px;
  }
}
</style>
